import { render, staticRenderFns } from "./PluginLoading.vue?vue&type=template&id=1e6fedba&scoped=true"
import script from "./PluginLoading.vue?vue&type=script&lang=js"
export * from "./PluginLoading.vue?vue&type=script&lang=js"
import style0 from "./PluginLoading.vue?vue&type=style&index=0&id=1e6fedba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6fedba",
  null
  
)

export default component.exports